import type { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { put, takeLatest, call } from 'redux-saga/effects';

import { formSubmitDynamics, DynamicsSubmitPayload } from 'components/Form/FormSubmitDynamics';
import { SUBMIT_DYNAMICS_FORM, SUBMIT_FORM_BEGIN, SUBMIT_FORM_ERROR, SUBMIT_FORM_COMPLETE } from 'store/actionTypes';

import { BeginSubmitFormAction } from './submitFormSagas';

function* submitDynamicsFormSaga(action: SubmitDynamicsFormAction) {
    const { formElement, formId, formApiUrl, items, reduxSubmitAction, identifier, appInsights } = action.payload;

    yield put({ type: SUBMIT_FORM_BEGIN, id: identifier });

    try {
        yield call(formSubmitDynamics, {
            formElement,
            formId,
            formApiUrl,
            items,
        });
        appInsights?.trackEvent({
            name: 'FormDynamics_Submit_Success',
            properties: {
                epiFormId: identifier,
                dynamicsFormId: formId,
            },
        });
        yield put(reduxSubmitAction); // Proceed with backend post if needed
    } catch (err) {
        appInsights?.trackEvent({
            name: 'FormDynamics_Submit_Error',
            properties: {
                epiFormId: identifier,
                dynamicsFormId: formId,
                error: err,
            },
        });
        yield put({
            type: SUBMIT_FORM_ERROR,
            id: identifier,
            payload: {
                errorMessage: `<strong>Dynamics365 Error:</strong> ${err}`,
            },
        });
    } finally {
        yield put({ type: SUBMIT_FORM_COMPLETE, id: identifier });
    }
}

function* dynamicsFormSagas(): Generator {
    yield takeLatest(SUBMIT_DYNAMICS_FORM, submitDynamicsFormSaga);
}

export default dynamicsFormSagas;

export interface SubmitDynamicsFormAction {
    type: typeof SUBMIT_DYNAMICS_FORM;
    payload: DynamicsSubmitPayload & {
        reduxSubmitAction: BeginSubmitFormAction;
        identifier: string;
        appInsights: ReactPlugin;
    };
}
